import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNewAdmissionsPOAAsync } from '../../../app/workListSlice';
import { LIST_VIEW_LIMIT, NEW_ADMISSION_POA } from '../../../constants';
import { DataTable, Pagination } from '../../secondary';
import { useNavigate } from 'react-router-dom';

export const NewAdmissionPOA = ({ facilityNumber }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState(1);
    const [offSet, setOffSet] = useState(0)
    const [sortType, setSortType] = useState('')
    const getWorkListNewAdmissionPOA = () => {
        const listPayLoad = {};
        listPayLoad['url'] = NEW_ADMISSION_POA
        listPayLoad['method'] = 'Get'
        listPayLoad['queryParam'] = { offSet: 0, limit: LIST_VIEW_LIMIT , facilityNumber: facilityNumber}
        dispatch(getNewAdmissionsPOAAsync(listPayLoad))
    }

    useEffect(() => {
        if (facilityNumber) {
            getWorkListNewAdmissionPOA();
        }
    }, [dispatch, facilityNumber]);


    const patientList = useSelector(state => state.worklists.newAdmissionPOAData)


    const columns = [
        // {
        //     Header: 'Patient Profile Photo',
        //     accessor: 'profilePicture',
        //     imageData: 'picture',
        //     restWidth: '165px',
        //     disableSortBy: true,
        // },
        {
            Header: 'MRN #',
            accessor: 'mrn',

        },
        {
            Header: 'First name',
            accessor: 'firstName',

        },
        {
            Header: 'Last name',
            accessor: 'lastName',


        },
        {
            Header: 'Gender',
            accessor: 'gender',

        },
        {
            Header: 'Age',
            accessor: 'age',
            restWidth: '150px'

        },
        {
            Header: 'DOB',
            accessor: 'dob',
            restWidth: '180px'

        },
        {
            Header: 'Admission date',
            accessor: 'admissionDate',
            restWidth: '300px'

        },
        {
            Header: 'Discharge date',
            accessor: 'dischargeDate',
            restWidth: '300px'

        }

    ];

    //redirect
    const getSelectedRowData = (data) => {
        if (data) {
            navigate(`/${"patients"}/${data.ne1Id}`);
        }
    }

    const deleteDataList = () => {
    }

    const selectRowCount = () => {
    }

    const handleSort = useCallback(data => {
        if (data && data.sortBy[0] && data.sortBy[0].id) {
            const sortingColumn = data.sortBy[0]
            const sortingType = sortingColumn ? (sortingColumn.desc) ? ':DESC' : ':ASC' : ''
            let sortParam = sortingColumn.id + sortingType
            setSortType(sortParam)
            const listPayLoad = {};
            listPayLoad['url'] = NEW_ADMISSION_POA
            listPayLoad['method'] = 'Get'
            listPayLoad['queryParam'] = { offSet: isNaN(offSet)===true?0:offSet, limit: LIST_VIEW_LIMIT, facilityNumber: facilityNumber, sort: sortParam }
            setOffSet((((data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT) < LIST_VIEW_LIMIT) ? 0 : (data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT)
            dispatch(getNewAdmissionsPOAAsync(listPayLoad))
        }
    
    }, [dispatch, facilityNumber,offSet])
    
    const getActivePage = (data) => {
        setActivePage(data);
        const listPayLoad = {};
        listPayLoad['url'] = NEW_ADMISSION_POA
        listPayLoad['method'] = 'Get'
        listPayLoad['queryParam'] = { offSet: (((data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT) < LIST_VIEW_LIMIT) ? 0 : (data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT, limit: LIST_VIEW_LIMIT , facilityNumber: facilityNumber,sort: (sortType)?sortType:'' }
        dispatch(getNewAdmissionsPOAAsync(listPayLoad))
        
    }  


    return (
        <>
            {patientList?.newAdmissions &&
                <DataTable
                    columns={columns}
                    data={patientList && patientList.newAdmissions}
                    sorting={true}
                    getSelectedRowData={getSelectedRowData}
                    setSelectedRows={selectRowCount}
                    onSort={handleSort}
                    detailView={true}
                    deleteDataList={deleteDataList}
                    showFixedColumn={false}
                    workListView={true}
                    sortType={(sortType)?sortType:''}
                />
            }
            {(Array.isArray(patientList?.newAdmissions)) && (patientList?.newAdmissions.length > 1) &&<Pagination
                activePage={activePage}
                itemsCountPerPage={patientList?.metadata ? patientList?.metadata?.limit : 50}
                totalItemsCount={patientList?.metadata ? patientList?.metadata?.total : 0}
                getActivePage={getActivePage}
                reportView={true}
            />
            }


        </>
    )

}
